module.exports = __webpack_public_path__ + "40ff68fdffa2bc73385af2cf7de33de9.pdf";